<template>
  <v-container grid-list-md v-if="isLinkPaymentEnabled">
    <v-card class="mx-auto" color="white">
      <v-card-text class="px-0">
        <h2 class="font-weight-light pb-3 text-center">Sistema de Cobranças</h2>
      </v-card-text>
      <v-list three-line>
        <v-list-tile>
          <v-list-tile-content>
            <new-invoice />
          </v-list-tile-content>
        </v-list-tile>
        
        <v-divider inset></v-divider>
        <br />
        
        <v-list-tile>
          <v-list-tile-content>
            <v-card-actions class="headline font-weight-bold pa-0">
              <div class="headline font-weight-bold">Minhas Cobranças</div>
              <v-spacer></v-spacer>
              <v-btn fab small @click="show">
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-card-actions>
          </v-list-tile-content>
        </v-list-tile>
        
        <v-divider></v-divider>
        <br />
        
        <!-- Tabela integrada ao card -->
        <invoice-table />
      </v-list>
    </v-card>
    <filters />
  </v-container>
  <v-container grid-list-md text-xs-center class="background-billing" v-else>
    <v-layout row wrap class="align-bill">
      <v-card class="mx-auto" max-width="600" style="margin-top: 50px;">
        <v-card-text class="text-center">
          <v-icon size="64" color="grey lighten-1" class="mb-4">block</v-icon>
          <h2 class="headline mb-3">Sistema de Link de Pagamento Desabilitado</h2>
          <p class="body-1 grey--text text--darken-1">
            Esta funcionalidade não está disponível no momento. 
            Entre em contato com seu representante para mais informações.
          </p>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { EventBus } from '@/services/event-bus';

export default {
  name: 'Internet',
  created() {
    this.$store.dispatch("system/fetchSystemConfiguration").then(() => {
      this.$store.dispatch("account/isLinkPaymentEnabled");
    });
    this.$store.dispatch("account/getAccount");
  },
  mounted() {

  },
  computed: {
    ...mapGetters({
      invoices: 'invoices/getList',
      isLinkPaymentEnabled: "account/isLinkPaymentEnabled",
    }),
  },
  components: {
    Filters: () => import('./Filters.vue'),
    NewInvoice: () => import('./NewInvoice'),
    InvoiceTable: () => import('./InvoiceTable.vue'),
  },
  methods: {
    show() {
      this.$store.dispatch('invoices/showFilters');
    },
  },
  data: () => ({
    dialog: false
  })
};
</script>

<style>
  .background-billing {
    background-color: #FFFFFF;
  }
  .align-bill {
    display: block;
    text-align: center;
  }
</style>
